import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

export function OeKpiChartSelect<T>({
  value,
  setValue,
  items,
  label,
}: {
  value: T;
  setValue: React.Dispatch<React.SetStateAction<T>>;
  items: { id: string; value: T; label: string }[];
  label: string;
}) {
  return (
    <FormControl fullWidth>
      <InputLabel id="scale-select-label">{label}</InputLabel>
      <Select
        labelId={`${label}-select-label`}
        value={value}
        label={label}
        sx={{
          height: "36px",
          borderRadius: "5px",
        }}
        onChange={(event) => {
          const {
            target: { value },
          } = event;

          setValue(value as T);
        }}
      >
        {items.map(({ id, value, label }) => (
          <MenuItem id={id} value={`${value}`}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
